<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
// import create from "../../create";
import util from "@/option/common/util";
import companyIcon from "@/assets/img/newCompany.png"; // 公司图标
import factoryIcon from "@/assets/img/newFactory.png"; // 工厂图标
import provinceBgIcon from "@/assets/img/provinceBg.png"; // 省市区显示名称的背景图
import areaBgIcon from "@/assets/img/areaBg.png"; // 区域显示名称的背景图
import mapBg from "./map_bg_bak.png"; // 地图渲染背景图
import {getMapData} from '@/api/map';

// 以下参考引入文件areaData.js中的注释
import {
  AREA_LIST,
  AREA_CODE_NAME_MAP,
  AREA_DISTANCE_MAP,
  AREA_NAME_LIST,
  AREA_CODE_MAP,
  AREA_NAME_MAP,
  AREA_JSON_MAP,
  HAI_NAN_JSON,
  PROVINCE_LIST,
  AREA_CP_MAP
} from '@/utils/areaData.js'


// 写死的双碳业务场景下的单位对应指标名称map
const fieldsUnitMap = {
  工厂数量: "家",
  水泥产量: "万吨/年",
  熟料产量: "万吨/年",
  碳排放强度: "tCO2/t",
};

const geo3DOption = { // geo3D配置项，3D地图的主要配置项，主要处理3d地图本身的渲染，参考echarts geo3D配置
  map: "china",
  roam: true,
  type: "geo3D",
  instancing: true,
  boxHeight: 20,
  regionHeight: 3.6,
  silent: true,
  itemStyle: {
    opacity: 1,
    borderWidth: 0.8,
    borderColor: "#52F1F5",
    emphasis: {
      disabled: false,
    },
  },
  label: {
    show: false,
  },
  emphasis: {
    disabled: true,
    label: {
      show: false,
    },
  },
  shading: "realistic",
  realisticMaterial: {
    textureTiling: 1,
    textureOffset: 0,
    detailTexture: mapBg,
    roughness: 0,
    metalness: 0,
    roughnessAdjust: 0,
  },
  postEffect: {
    enable: false,
  },
  viewControl: {
    autoRotate: true,
    autoRotateDirection: "cw",
    autoRotateSpeed: 100,
    beta: 10,
    minBeta: -90,
    maxBeta: 10,
    alpha: 65,
    distance: 100,
    center: [0, -15, 0],
  },
  light: {
    main: {
      color: "#52F1F5",
      intensity: 7,
      shadowQuality: "midum",
      shadow: false,
      alpha: 173,
      beta: 190,
    },
    ambient: {
      color: "#ffffff",
      intensity: 0.2,
    },
  },
}

const titleOption = { // 标题配置项
  text: "地图",
  textStyle: {
    fontWeight: "bold",
    fontSize: 13,
    color: "#000000",
    fontStyle: "normal",
  },
  show: false,
  left: "8px",
  top: "8px",
}
let toolTipOption = {
  show: true,
  backgroundColor: 'none',
  borderColor: 'none',
  borderWidth: 0,
  padding: 0,
}

const scatter3DRichOption = {
  factory: {
    width: 40,
    height: 30,
    backgroundColor: {
      image: factoryIcon,
    },
  },
  area: {
    width: 40,
    height: 30,
    backgroundColor: {
      image: companyIcon,
    },
  },
  text: {
    color: "#ffffff",
    fontSize: 9,
    align: "center",
    verticalAlign: "top",
    width: "120%",
    height: 14,
    padding: [0, 5, 2, 5],
    backgroundColor: {
      image: areaBgIcon,
    },
  },
}

const labelRichOption = { // 富文本配置项, 根据ui设计展示label，具体参考echarts富文本标签文档
  area: {
    width: 60,
    height: 45,
    backgroundColor: {
      image: companyIcon
    }
  },
  text: {
    color: '#ffffff',
    fontSize: 13,
    align: 'center',
    verticalAlign: 'bottom',
    width: '120%',
    height: 21,
    padding: [0, 5, 2, 5],
    backgroundColor: {
      image: areaBgIcon
    }
  }
}

const scatter3DOption = {
  type: "scatter3D",
  coordinateSystem: "geo3D",
  geo3DIndex: 0,
  symbolSize: 85,
  symbol: "none",
  itemStyle: {
    borderWidth: 0.5,
    borderColor: "#fff",
  },
  label: {
    show: true,
    position: [0, 0],
    distance: 0,
    opacity: 1,
  },
}

const normalLabelOption = {
  show: true,
  align: 'center',
  verticalAlign: 'bottom',
  distance: -105,
  position: 'bottom',
  formatter: (params) => {
    // 格式化label，根据业务具体参考echarts富文本标签文档
    const data = params?.value[params?.value?.length - 1] || {}
    let dis = ''
    const dataLen = data?.name?.length || 0
    for (let i = 0; i < Math.floor(dataLen / 2); i++) {
      dis += '　'
    }
    return `${dis}{area|}\n{text|${data.name}} `
  },
}

const individualLabelOption = {
  show: true,
  align: 'center',
  verticalAlign: 'bottom',
  distance: -55,
  formatter: (params) => {
    const data = params.value[params.value.length - 1] || {}
    if (!AREA_NAME_LIST.includes(data.district)) {
      return '　　　　　　'
    } else {
      let dis = ''
      for (let i = 0; i < Math.floor(data.district.length / 2); i++) {
        dis += '　'
      }
      return `${dis}{area|}\n{text|${data.district}} `
    }
  },
}

const POSITION_MAP = {
  topCenter: {
    left: 'center',
    top: 'top',
  },
  topLeft: {
    left: 'left',
    top: 'top',
  },
  topRight: {
    top: 'top',
    left: 'right',
  },
  'bottomCenter': {
    top: 'bottom',
    left: 'center',
  },
  'bottomLeft': {
    top: 'bottom',
    left: 'left',
  },
  bottomRight: {
    top: 'bottom',
    left: 'right',
  }
}

// 格式化指标方法
import {formatValue} from "@/option/common/common.js";

export default {
  name: "newMap3D",
  data() {
    return {
      visualMap: undefined,
      bannerCount: 0,
      bannerCheck: "",
      centerData: [], // 中心点
      zoomData: 1,
      mapDataJson: '', // 地图json数据
      paramKey: '',
      renderDataChart: [],
      curAreaData: '', // 当前区域数据，用于渲染全国地图跳转到区域地图之后的业务，双碳业务
      filterDistrict: '', // 根据过滤条件获取区域，用于地图的被联动，双碳业务
    };
  },
  watch: {
    mapData() {
      this.updateChart();
    },
  },
  computed: {
    mapData() {
      return this.option.mapData || {};
    },
  },
  methods: {
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    // 根据配置项设置相关option的值
    generateOptions() {
      const {
        borderColor = '#52F1F5',
        itemStyleColor = undefined,
        showLegend = false,
        legendType = 'default',
        showToolTip = false,
        toolTipBgWidth = 200,
        toolTipBgHeight = 100,
        toolTipContent,
        showLabel = false,
        labelFontSize,
        labelColor,
        labelContent = [],
        labelMark,
        barColor = [],
        legendDirection = 'vertical',
        legendPosition = 'bottomLeft',
        legendSymbol = 'circle',
        legendWidth = 12,
        legendHeight = 12,
        legendFontSize = 12,
        legendFontColor = '',
      } = this.option
      geo3DOption.itemStyle.borderColor = borderColor
      geo3DOption.itemStyle.color = itemStyleColor
      if (itemStyleColor) {
        geo3DOption.realisticMaterial.detailTexture = itemStyleColor
      } else {
        geo3DOption.realisticMaterial.detailTexture = mapBg
      }
      normalLabelOption.show = showLabel
      labelRichOption.text.fontSize = labelFontSize
      labelRichOption.text.color = labelColor
      normalLabelOption.formatter = (params) => {
        // 格式化label，根据业务具体参考echarts富文本标签文档
        const data = params?.value[params?.value?.length - 1] || {}
        let dis = ''
        const dataLen = data?.name?.length || 0
        for (let i = 0; i < Math.floor(dataLen / 2); i++) {
          dis += '　'
        }
        let label = ''
        let content = ''
        // return `${dis}{area|}\n{text|${data.name}} `
        if (labelMark === 'custom' && data.name) {
          let matchItem = Object.values(labelRichOption).find(item => item?.name === data.name)
          if (matchItem) {
            label += `${dis}{${matchItem?.randomKey}|}\n`
          }
        }
        if (labelContent.includes('dimension')) {
          content += data.name
        }
        if (labelContent.includes('metric')) {
          Object.keys(data).forEach(key => {
            if (key !== 'name') {
              content += data[key]
            }
          })
        }
        return `${label}{text|${content}} `
      }
      // let pieces = []
      // if (barColor.length) {
      //   pieces = barColor.map(item => {

      //   })
      // }
      if (showLegend) {
        this.visualMap = {
          show: showLegend,
          type: legendType === 'default' ? 'piecewise' : legendType,
          orient: legendDirection,
          inRange: {
            color: barColor.map(item => item.color1),
            symbol: legendSymbol,
            symbolSize: [legendWidth, legendHeight]
          },
          hoverLink: false,
          ...POSITION_MAP[legendPosition],
          textStyle: {
            fontSize: legendFontSize,
            color: legendFontColor,
          },
        }
      } else {
        this.visualMap = undefined
      }
      toolTipOption = {
        ...toolTipOption,
        show: showToolTip,
      }
    },
    // 地图工厂之间飞线配置项代码，具体参考echart 3d飞线配置
    initFactoryData(markData) {
      const lineData = []
      markData.forEach((item, index) => {
        lineData.push([[item.value[0], item.value[1]], this.curAreaData.cp])
      })
      // 飞线
      const lineSeries = {
        type: 'lines3D',
        coordinateSystem: 'geo3D',
        effect: {
          show: true,
          trailWidth: 3,
          trailOpacity: 0.5,
          trailLength: 0.2,
          constantSpeed: 5
        },
        blendMode: 'lighter',
        lineStyle: { // 航线的视图效果
          color: '#FFB800',
          width: 1,
          opacity: 0.6
        },
        data: lineData
      }
      return lineSeries
    },
    // 地图json数据请求
    async getMapData() {
      if (!this.mapDataJson && this.mapData) {
        const res = await getMapData(this.mapData)
        this.mapDataJson = res.data
      }
    },
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop.metrics.find(item => item.fieldName === name) || {}
      return fieldItem?.set?.indexUnit || ''
    },
    // 格式化
    getFormatVal(name) {
      const fieldItem = this.prop.metrics.find(item => item.fieldName === name) || {}
      return formatValue(fieldItem.set, fieldItem, 'value')
    },
    // 获取当前地图的过滤条件，根据过滤条件的区域渲染地图，双碳业务
    initFilterData() {
      const {
        filterDatas = {}
      } = this.prop
      if (filterDatas.conditions && filterDatas.conditions.length) {
        const condition = filterDatas.conditions.find(item => item.code && item.code === 'district') || {}
        this.filterType = condition.code
      }
      if (this.linkData && this.filterType) {
        const [id, field] = filterDatas.conditions[0].bindKey.split('.')
        if (this.linkData[id] && this.linkData[id][field] && this.linkData[id][field].value) {
          this.filterDistrict = this.linkData[id][field].value
        }
      }
    },
    // 判断是否双碳业务模型，由于业务模型的id会变，用名称判断
    isIndividual() {
      let individual = false
      if (this.prop.dataCenter) {
        this.prop.dataCenter?.appList?.forEach(item => {
          if (item.code === this.prop.dataCenter?.modelType && item.name?.indexOf('双碳') >= 0) {
            individual = true
          }
        })
      }
      return individual
    },
    // 全局一致的更新图表方法
    async updateChart() {
      // if (!this.isDataCenter){
      //   return
      // }
      this.initFilterData()
      this.generateOptions()
      let option
      // 双碳走特殊数据处理,
      if (this.isIndividual()) {
        option = await this.generateIndividualOptionData()
      } else {
        // 非双碳走普通数据处理
        option = await this.generateNormalOptionData()
      }
      this.myChart.off("mouseover");
      this.myChart.off("mouseout");
      this.myChart.off("georoam");
      // 报错注释掉
      // this.myChart.on("mouseover", (e) => {
      //     console.log('e>>>>>>', e)
      // });
      // 地图缩放监听
      this.myChart.on("georoam", (e) => {
        const option = this.myChart.getOption();
        const geo = option.geo[0];
        this.centerData = geo.center;
        this.zoomData = geo.zoom;
        if (this.zoomData < 1) this.zoomData = 1;
      });

      this.myChart.resize();
      // 3d地图需要异步渲染option，否则可能会发生渲染bug，临时解决方案，dataease中也有此问题，框架并未解决
      setTimeout(() => {
        this.myChart.setOption(this.echartsOptionHandler(option), true);
      }, 300)
    },
    handleHaiNanFeature() {
      // 接口返回的是字符串，转一下
      const jsonData = JSON.parse(this.mapDataJson)
      // 处理海南省的geoJson数据，因为海南省的数据默认包含三沙市和南海诸岛及九段线，会占据较大的渲染空间
      const haiNanFeature = jsonData.features.find(feat => feat.properties.name === '海南省')
      haiNanFeature.geometry = HAI_NAN_JSON.geometry
      jsonData.features = [...jsonData.features.filter(feat => feat.properties.name && feat.properties.name !== '海南省'), haiNanFeature]
      // 处理海南省数据完毕
      // 下面要做数据处理，直接深拷贝，避免引用
      const optionData = this.deepClone(jsonData);
      return optionData
    },
    handleAreaFeature() {
      const newFeature = []
      const jsonData = JSON.parse(this.mapDataJson)
      // 按区域层级处理地图数据结构，双碳业务
      Object.keys(AREA_CODE_MAP).forEach((distKey, distIndex) => {
        const distPro = []
        AREA_CODE_MAP[distKey].forEach(pro => {
          jsonData.features.forEach(fea => {
            if (pro === ('156' + fea.properties.adcode)) {
              distPro.push(fea)
            }
          })
        })
        // 区域数据项结构，此结构基本固定，参考地图数据的geoJson， 双碳业务
        const disProObj = {
          geometry: {
            coordinates: AREA_JSON_MAP[distKey].features[0].geometry.coordinates,
            type: AREA_JSON_MAP[distKey].features[0].geometry.type
          },
          properties: {
            acroutes: [100000],
            adcode: distKey.replace('156', '') * 1,
            level: 'province',
            name: AREA_NAME_MAP[distKey],
            cp: AREA_CP_MAP[distKey],
            center: AREA_CP_MAP[distKey],
            centroid: AREA_CP_MAP[distKey],
            parent: {
              adcode: 100000
            },
            childrenNum: distPro.length,
            childrennum: distPro.length,
            subFeatureIndex: distIndex + 1,
            subfeatureindex: distIndex + 1
          },
          type: 'Feature'
        }
        newFeature.push(disProObj)
      })
      // 处理海南数据
      const haiNanFeature = jsonData.features.find(feat => feat.properties.name === '海南省')
      haiNanFeature.geometry = HAI_NAN_JSON.geometry
      // 根据过滤条件的区域，过滤出需要渲染的地图数据，双碳业务
      if (this.filterDistrict) {
        const value = this.filterDistrict
        const areaCode = AREA_CODE_NAME_MAP[value]
        this.curAreaData = AREA_LIST.find(item => item.code === areaCode)
        renderData.push({
          name: this.curAreaData.name, value: [...this.curAreaData.cp, this.curAreaData.name, {
            district: this.curAreaData.name
          }]
        })
        const list = AREA_CODE_MAP[areaCode]
        const countryCode = areaCode.substring(0, 3)
        jsonData.features = jsonData.features.filter(item => {
          return list.includes(countryCode + item.properties.adcode)
        })
      } else {
        // 全国地图数据
        jsonData.features = [...newFeature, ...jsonData.features.filter(feat => !PROVINCE_LIST.includes(feat.properties.name) && feat.properties.name && feat.properties.name !== '海南省'), haiNanFeature]
      }
      const optionData = this.deepClone(jsonData);
      return optionData
    },
    generateAssistStr(metric, assistList, assistMetrics) {
      let str = ''
      const {
        assistMetricName = {},
        assistMetricValue = {},
      } = this.option
      metric?.set?.assistIndexs?.forEach((assItem, index) => {
        let formatVal = assistList[index].value
        let assistMet = assistMetrics.find(assMet => assMet.code === assItem.indexField) || {}
        if (assItem.showVal === 'differPCT') {
          formatVal = `${formatVal.toFixed(2)}%`
        }
        if (assItem.showVal === 'differAbs') {
          formatVal = Math.abs(formatVal)
        }
        str += `<div
                  style="margin-bottom: 10px"
                >
                  <span
                    style="
                      font-size:${assistMetricName.fontSize} px;
                      color: ${assistMetricName.fontColor};
                      font-weight: ${assistMetricName.fontWeight};"
                  >${assistMet?.name} ${assItem.des || ''}</span>:
                  <span
                    style="
                      font-size:${assistMetricValue.fontSize}px;
                      color: ${assistMetricValue.fontColor};
                      font-weight: ${assistMetricValue.fontWeight};"
                  >${formatVal} ${assistMet?.set?.indexUnit || ''}</span>
                </div>`
      })
      return str
    },
    assistMetricsToolFormatter(data, prop, dataChart, series) {
      const {assistMetrics, metrics} = prop
      const {
        metricName = {},
        metricValue = {},
      } = this.option
      let res = "";
      Object.keys(data).forEach((v, i) => {
        if (v !== 'name') {
          const originName = (series.find(item => item.name === v) || {}).originName
          const metric = metrics.find(met => v === met.name || originName === met.name)
          const dataChartItem = dataChart.find(item => {
            return Object.values(item).find(itm => itm.value === data.name)
          }) || {}
          // 分组的data和不分组的data顺序表示的内容不一样
          const assistList = dataChartItem[metric?.code]?.assistList
          let str = this.generateAssistStr(metric, assistList, assistMetrics)
          res += `<div>
                    <div>
                      <div>
                        <span
                          style="
                            font-size:${metricName.fontSize}px;
                            color: ${metricName.fontColor};
                            font-weight: ${metricName.fontWeight};"
                        >${v}</span>:
                        <span
                          style="
                            font-size:${metricValue.fontSize}px;
                            color: ${metricValue.fontColor};
                            font-weight: ${metricValue.fontWeight};"
                        >${data[v]} ${metric?.set?.indexUnit || ''}</span>
                      </div>
                      <div>
                        ${str}
                      </div>
                    </div>
                  </div>`;
        }
      });
      return res;
    },
    toolFormatter(params, series) {
      const {
        toolTipBgImg,
        toolTipBgWidth = 100,
        toolTipBgHeight = 50,
        toolTipContent,
        metricName = {},
        metricValue = {},
        dimension = {},
      } = this.option
      const data = params.value[params.value.length - 1] || {}
      let domStr = ''
      if (this.option.assistTip) {
        domStr = this.assistMetricsToolFormatter(data, this.prop, this.dataChart, series)
      } else {
        Object.keys(data).forEach(item => {
          if (item !== 'name') {
            const unit = this.getUnit(item)
            domStr += `<div>
                      <span
                        style="
                          font-size:${metricName.fontSize}px;
                          color: ${metricName.fontColor};
                          font-weight: ${metricName.fontWeight};"
                      >${item}: </span>
                      <span
                        style="
                          font-size:${metricValue.fontSize}px;
                          color: ${metricValue.fontColor};
                          font-weight: ${metricValue.fontWeight};"
                      >${data[item]} ${unit}</span>
                    </div>`
          }
        })
      }
      return `<div  style="background:url(${toolTipBgImg}) no-repeat; background-size:100% 100%; width: ${toolTipBgWidth}px; height: ${toolTipBgHeight}px;">
                <div style="
                      font-size:${dimension.fontSize};
                      color: ${dimension.fontColor};
                      font-weight: ${dimension.fontWeight};">${data.name}</div>
                ${domStr}
              </div>`
    },
    initAreaColor(categories) {
      const areaNameList = JSON.parse(this.mapDataJson)?.features?.map(item => item?.properties?.name)
      let regions = []
      let pieces = []
      categories.forEach((catItem, index) => {
        if (areaNameList.includes(catItem) && this.option.barColor.length) {
          regions.push({
            name: catItem,
            itemStyle: {
              color: this.option.barColor[index] ? this.option.barColor[index]?.color1 : '#D8D818',
            },
          })
          pieces.push({value: index, label: catItem, color: this.option.barColor[index]?.color1})
        }
      })
      if (regions.length) {
        geo3DOption.regions = regions
      }
      if (this.option.showLegend) {
        this.visualMap.pieces = pieces
      }
    },
    async generateRenderDataChart(categories) {
      let resList = []
      let promiseList = []
      this.dataChart.forEach(dataItem => {
        let keyValObj = {}
        Object.keys(dataItem).forEach(key => {
          if (typeof dataItem[key] === 'string') {
            keyValObj[key] = dataItem[key]
          } else if (typeof dataItem[key] === 'object' && dataItem[key] !== null) {
            keyValObj[key] = dataItem[key].value
          }
        })
        this.prop.signFilterData.forEach(ruleItem => {
          promiseList.push(util.parseSignRule(ruleItem, keyValObj, (type) => {
            if (type === 'match') {
              resList.push({
                ...keyValObj,
                signImg: ruleItem.img
              })
              const richKey = Object.values(keyValObj).find(val => categories.includes(val))
              const randomKey = new Date().getTime();
              if (richKey) {
                labelRichOption[`${randomKey}`] = {
                  ...labelRichOption.area,
                  name: richKey,
                  randomKey: `${randomKey}`,
                  backgroundColor: {
                    image: ruleItem.img
                  }
                }
              }
            }
          }))
        })

      })
      await Promise.all(promiseList)
      this.renderDataChart = resList
    },
    // 生成地图通用配置项, 地图配置项核心代码，可参考
    async generateNormalOptionData() {
      // 获取维度，指标数据，注：经度纬度用指标处理
      const {
        categories = [],
      } = this.getDimentionOption()

      // 获取地图渲染的json数据
      if (!this.mapDataJson) {
        await this.getMapData()
      }
      if (this.prop.signFilterData && this.prop.signFilterData.length) {
        await this.generateRenderDataChart(categories)
      }
      let {
        categories: _categories, // 重新取值
        series = [],
        longitude = [],
        latitude = [],
        seriesL = [],
        seriesR = [],
      } = this.getDimentionOption()
      if (!longitude.length && !latitude.length) {
        longitude = seriesL
        latitude = seriesR
      }
      this.initAreaColor(_categories)
      const optionData = this.handleHaiNanFeature()
      // 注册到window，这个不是一定要做的，但是avue框架默认是这么处理，抄过来了
      window.echarts.registerMap("china", optionData);
      // 因为经纬度不是单独的数据项，是和指标放在一起的，所以要做数据处理
      let seriesObj = {}
      series.forEach(item => {
        seriesObj[item.name] = item.data
      })
      // 生成option中传入的data渲染数据，主要处理指标数据等的渲染
      const renderData = _categories.map((item, index) => {
        let obj = {}
        /* 地图标点，塞入option的渲染数据的value格式，当前使用的是
          [经度，纬度，名称，数据项（业务上tooltip可能需要展示多个指标，所以该数据项会塞入全部指标，以及其他为了方便渲染所需的数据）]
          其他类型value格式可参考echarts3d地图文档
        */
        let longitudeData = ''
        let latitudeData = ''
        if (longitude.length && latitude.length) {

          Object.keys(seriesObj).forEach(key => {
            const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
            obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
            obj.name = item
          })
          longitudeData = longitude[0].data[index]?.value || longitude[0].data[index]
          latitudeData = latitude[0].data[index]?.value || latitude[0].data[index]
        } else {
          Object.keys(seriesObj).forEach(key => {
            const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
            if (key === '经度') {
              longitudeData = code ? seriesObj[key][index][code] : seriesObj[key][index]
            } else if (key === '纬度') {
              latitudeData = code ? seriesObj[key][index][code] : seriesObj[key][index]
            } else {
              obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
            }
            obj.name = item
          })
        }
        return {
          label: {
            ...normalLabelOption,
            rich: {
              ...labelRichOption,
            }
          },
          emphasis: { // 鼠标hoverlabel时的格式化label，参考echarts文档emphasis配置项
            disabled: false,
            label: {
              ...normalLabelOption,
              rich: {
                ...labelRichOption,
              },
            },
          },
          name: item,
          value: [
            `${longitudeData}`,
            `${latitudeData}`,
            item,
            obj,
          ]
        }
      })
      // 地图配置项，参考echarts 3D地图
      const option = {
        title: {
          ...titleOption,
        },
        tooltip: {
          ...toolTipOption,
          formatter: (params) => {
            return this.toolFormatter(params, series)
          },
        },
        visualMap: this.visualMap,
        geo3D: {...geo3DOption},
        series: [ // 根据指标数据，在地图上标点展示，参考geo3D的series配置
          {
            ...scatter3DOption,
            data: renderData,
          },
        ],
      };
      return option
    },
    // 生成双碳地图配置项，相关配置项注释，参考generateNormalOptionData的注释，大部分是重复的
    async generateIndividualOptionData() {
      const {
        categories = [],
        series = [],
        longitude = [],
        latitude = [],
      } = this.getDimentionOption()
      let seriesObj = {}
      series.forEach(item => {
        seriesObj[item.name] = item.data
      })
      const renderData = categories.map((item, index) => {
        let obj = {}
        let longitudeData = ''
        let latitudeData = ''
        if (longitude.length && latitude.length) {
          Object.keys(seriesObj).forEach(key => {
            const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
            obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
            obj.district = item
          })
          const {code: NumberCode} = this.prop.metrics.find(metItem => metItem.fieldName === '工厂数量')
          longitudeData = (longitude[0].data[index]?.longitude || longitude[0].data[index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
          latitudeData = (latitude[0].data[index]?.latitude || latitude[0].data[index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
        } else {
          Object.keys(seriesObj).forEach(key => {
            const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
            const {code: NumberCode} = this.prop.metrics.find(metItem => metItem.fieldName === '工厂数量')
            if (key === '经度') {
              longitudeData = (code ? seriesObj[key][index][code] : seriesObj[key][index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
            } else if (key === '维度') {
              latitudeData = (code ? seriesObj[key][index][code] : seriesObj[key][index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
            } else {
              obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
            }
            obj.district = item
          })
        }
        return {
          label: {
            ...individualLabelOption,
            rich: {
              ...labelRichOption,
            },
          },
          emphasis: {
            disabled: false,
            label: {
              ...individualLabelOption,
              rich: {
                ...labelRichOption,
              },
            },
          },
          name: item,
          value: [
            `${longitudeData}`,
            `${latitudeData}`,
            item,
            obj,
          ]
        }
      })
      if (!this.mapDataJson) {
        await this.getMapData()
      }
      // 双碳特殊的地图数据处理
      const optionData = this.handleAreaFeature();
      window.echarts.registerMap("china", optionData);
      const curAreaData = this.curAreaData
      const option = {
        title: {
          ...titleOption,
          text: "集团驾驶舱地图",
        },
        tooltip: {
          ...toolTipOption,
          formatter: function (params) {
            const data = params.value[params.value.length - 1] || {}
            let domStr = ''
            Object.keys(data).forEach(item => {
              if (item !== 'company' && item !== 'district') {
                domStr += `<div style="font-size: 8px;line-height:16px;margin-top:5px;display:flex;">
                          <span style="flex: 4;">${item}: </span>
                          <span style="flex: 6;color: #3FEBFF;">${(data[item] * 1 || 0).toFixed(item === '工厂数量' ? 0 : 2)}${fieldsUnitMap[item] || ''}</span>
                        </div>`
              }
            })
            return `<div style="background: #002b5c80;border: 1px solid #46A5E2;padding: 12px;color: #ffffff;min-width:200px;">
                      <div style="font-size: 13px;line-height:20px;">${data.company || data.district}</div>
                      ${domStr}
                    </div>`
          }
        },
        geo3D: geo3DOption,
        series: [
          {
            name: "工厂数量",
            type: "map3D",
            geoIndex: 0,
            data: renderData,
            itemStyle: {
              normal: {},
            },
            coordinateSystem: "geo3D",
            shading: "lambert",
            opacity: 1,
          },
          {
            ...scatter3DOption,
            label: {
              show: !!curAreaData, // 根据是区域还是全国判断是否展示label，双碳业务
              position: [20, 20],
              distance: -55,
              opacity: 1,
              formatter(params) {
                // 渲染区域和渲染公司的label展示要不一样，双碳业务
                const data = params.value[params.value.length - 1] || {}
                if (curAreaData && data.district === curAreaData.name) {
                  let dis = ''
                  for (let i = 0; i < Math.floor(data.district.length / 2); i++) {
                    dis += '　'
                  }
                  return `${dis}{area|}\n{text|${data.district}}`
                } else {
                  return `{factory|}`
                }
              },
              rich: {
                ...scatter3DRichOption,
              },
            },
            emphasis: {
              disabled: false,
              label: {
                show: !!curAreaData, // 根据是区域还是全国判断是否展示label的放大，双碳业务
                formatter(params) {
                  const data = params.value[params.value.length - 1] || {}
                  if (curAreaData && data.district === curAreaData.name) {
                    return `{area|}\n{text|${data.district}}`
                  } else {
                    return `{factory|}`
                  }
                },
                rich: {
                  ...scatter3DRichOption,
                  factory: {
                    ...scatter3DRichOption.factory,
                    width: 50,
                    height: 40,
                  },
                  area: {
                    ...scatter3DRichOption.area,
                    width: 50,
                    height: 40,
                  },
                },
              },
            },
            // 区域和全国的数据展示不同，双碳业务
            data: !curAreaData ? renderData : renderData.map(item => ({
              name: (item.value[item.value.length - 1] || {}).district,
              value: item.value
            })),
          },
        ],
      };
      // 如果是区域地图，需要有公司到公司之间的飞线动效，双碳业务
      if (this.curAreaData) {
        const lineData = this.initFactoryData(renderData)
        option.series.push(lineData)
        option.geo3D.viewControl.distance = this.curAreaData?.name ? AREA_DISTANCE_MAP[this.curAreaData?.name] : 100
        option.geo3D.regionHeight = this.curAreaData?.name ? (AREA_DISTANCE_MAP[this.curAreaData?.name] / 100) * 3.6 : 3.6
      }
      return option
    }
  },
};
</script>
